  <div class="relative bg-[var(--white)] p-8 max-w-md mx-auto rounded-xl shadow-lg">
    <div class="">
      <h2 class="text-[var(--dark-orange)] font-normal text-[45px]/[45px] text-left w-full">{{ data.title }}</h2>
      <button 
        class="absolute top-[16px] right-[16px] border border-[3px] border-[var(--dark-orange)] rounded-full p-1" 
        (click)="closeModal()"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          class="h-3 w-3" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="var(--dark-orange)"
        >
          <path 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            stroke-width="6" 
            d="M6 18L18 6M6 6l12 12" 
          />
        </svg>
      </button>
    </div>

    <div class="w-[var(-webkit-fill-available)] h-[8px] mb-4 mt-2" style="border-top:1px dotted var(--grey)"></div>
  
    <div class="flex justify-center">
        <div class="">
            <p class="text-[var(--black)] text-[21px]/[31px] font-normal">{{data.message}}</p>
        </div>
    </div>

  </div>